/**
 * Landing-page navigation tiles for Design Check.
 * Mirrors the header nav so first-time visitors immediately see what they
 * can do. Sales/admin users get an extra tile for client invites.
 */

import React from 'react';
import { Link } from 'react-router-dom';

const INTERNAL_ROLES = ['admin', 'sales'];

function NavTiles() {
  const role = localStorage.getItem('userRole');
  const canInvite = INTERNAL_ROLES.includes(role);

  return (
    <div className="dc-tiles">
      <Link to="/design-check/chat" className="dc-tile">
        <span className="dc-tile-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </span>
        <b>Ask Bob</b>
        <p>Talk to our AI print engineer about materials, orientation and design choices.</p>
      </Link>

      <Link to="/design-check/guide" className="dc-tile">
        <span className="dc-tile-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
          </svg>
        </span>
        <b>Design guide</b>
        <p>Learn how to design parts for large-format robotic 3D printing.</p>
      </Link>

      {canInvite && (
        <Link to="/design-check/invites" className="dc-tile">
          <span className="dc-tile-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="8.5" cy="7" r="4" />
              <line x1="20" y1="8" x2="20" y2="14" />
              <line x1="23" y1="11" x2="17" y2="11" />
            </svg>
          </span>
          <b>Client invites</b>
          <p>Give a client time-limited access and follow what they upload and ask.</p>
        </Link>
      )}
    </div>
  );
}

export default NavTiles;
